import { AnimatePresence, motion } from 'framer-motion';
import { Photo } from '../Photo/Photo';
import styles from './Message.module.css';
import { iconsSources } from '../../helpers/icons';
import logo from '../../assets/images/logo.png';
import leftPresent from '../../assets/images/left.png';
import rightPresent from '../../assets/images/right.png';

import posterDefault from '../../assets/images/bgPoster1.webp';
import bgDefaultVideo from '../../assets/video/bgVideo1.webm';

const Message = ({ message, messageF2, rotateSign }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <div className={styles.wrapper}>
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={logo}
        alt="logo"
        className={styles.logo}
      />

      <div className={styles.messageBlock}>
        <AnimatePresence mode="popLayout">
          {message && (
            <motion.div
              key={`${message?.id}-msg}`}
              initial={{ y: '100vh' }}
              animate={{ y: '0' }}
              transition={{ duration: 2 }}
              exit={{ y: '-100vh' }}
            >
              <div className={styles.avatarBlock}>
                <img
                  className={styles.avatar}
                  src={
                    (message?.image !== '1' && message?.image) ||
                    iconsSources[message?.channel]
                  }
                  alt={message?.author}
                  onError={errorHandler}
                />

                {message?.author && (
                  <div className={styles.author}>{message?.author}</div>
                )}
              </div>

              <div className={styles.contentBlock}>
                <div>{message?.content}</div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className={styles.photoBlock}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className={styles.photoText}
        >
          Поздравляем!
        </motion.div>
        <AnimatePresence mode="wait">
          {messageF2 && (
            <motion.div
              key={messageF2?.id}
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.1, 1] }}
              transition={{ duration: 0.5, times: [0, 0.85, 1] }}
              exit={{ scale: 0 }}
              className={styles.photoImg}
            >
              <Photo message={messageF2} rotateSign={rotateSign} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={leftPresent}
        alt="present"
        className={styles.leftPresent}
      />

      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        src={rightPresent}
        alt="present"
        className={styles.rightPresent}
      />

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
};

export default Message;
